import _ from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {formatTableParams} from 'utils/index'
import {getResignList, getResignStat, exportData} from './service'

const model = createProjectModel({
    namespace: 'statResign',
    state: {
        tableData: {},
        resignStat: {},
    },

    effects: {
        *getTableList(x, {select, put, call}) {
            const {tableData} = yield select(({statResign}) => statResign)
            const params = formatTableParams(tableData)
            const res = yield call(getResignList, params)
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },

        *getResignStat(x, {put, call}) {
            const res = yield call(getResignStat)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.resignStat = res.data
                },
            })
        },

        // 导出数据
        *exportData(x, {call, select}) {
            const {tableData} = yield select((allState) => allState[model.namespace])
            const params = formatTableParams(tableData)
            return yield call(exportData, params)
        },
    },
})
export default model
